import { createAction, props } from '@ngrx/store';

export const loadMapSettings = createAction('[MapSettings] Load MapSettings');

export const loadMapSettingsSuccess = createAction(
  '[MapSettings] Load MapSettings Success',
  props<{ mapSettings: any }>(),
);

export const saveMapSettings = createAction('[MapSettings] Save MapSettings');
export const saveMapSettingsSuccess = createAction(
  '[MapSettings] Save MapSettings Success',
);

export const setBaseMap = createAction(
  '[MapSettings] Set Base Map',
  props<{ baseMap: 'roadmap' | 'hybrid' }>(),
);

export const toggleTrafficLayer = createAction(
  '[MapSettings] Toggle Traffic Layer',
);

export const toggleLocationLayer = createAction(
  '[MapSettings] Toggle Location Layer',
);

export const setSelectedLayer = createAction(
  '[MapSettings] Set Selected Layer',
  props<{ selectedLayer: string | null }>(),
);

export const setMapLoaded = createAction('[MapSettings] Map Loaded');
